(() => {
  const initSection = (section) => {
    if (!section?.classList.contains('nb-platform-steps-section')) return;

    const tabs = section.querySelectorAll('.nb-ps__tab');
    const panels = section.querySelectorAll('.nb-ps__panel');

    if (!tabs.length || !panels.length) return;

    const activate = (tabId) => {
      tabs.forEach((t) => t.classList.toggle('nb-ps__tab--active', t.dataset.tabId === tabId));
      panels.forEach((p) => p.classList.toggle('nb-ps__panel--active', p.dataset.panelId === tabId));
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab.dataset.tabId));
      tab.addEventListener('mouseenter', () => activate(tab.dataset.tabId));
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate(tab.dataset.tabId);
        }
      });
    });
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener('shopify:section:load', (e) => initSection(e.target));
})();
